import a from "react";
import { useLatestValue as n } from "./use-latest-value.js";

var o = function o(t) {
  var e = n(t);
  return a.useCallback(function () {
    return e.current.apply(e, arguments);
  }, [e]);
};

export { o as useEvent };